import { HttpClient } from '@angular/common/http'
import { Environment } from '@fabrik/common'
import { Observable, of, range } from 'rxjs'
import { concatMap, reduce, switchMap } from 'rxjs/operators'

import { Checkin, CheckinsResponse, CheckinLocationOption } from '../models/Checkin'
import moment from 'moment'

export class CheckinsDataService {
    constructor(private environment: Environment, private http: HttpClient) {}
    getCheckins(tenantId: string, startDate?: Date, endDate?: Date, locationId?: string | null, pageSize: number = 20): Observable<Checkin[]> {
        const limit = pageSize

        const buildUrl = (currentPage: number): string => {
            const params: string[] = [`tenantId=${tenantId}`, `limit=${limit}`, `page=${currentPage}`]

            if (startDate && endDate) {
                params.push(`startDate=${moment(startDate).utc().toISOString()}`)
                params.push(`endDate=${moment(endDate).utc().toISOString()}`)
            }

            if (locationId) {
                params.push(`locationId=${locationId}`)
            }

            return `${this.environment.appApiHost}/api/${tenantId}/admin/directory/tenantCheckins?${params.join('&')}`
        }

        const fetchPage = (currentPage: number): Observable<CheckinsResponse> => {
            return this.http.get<CheckinsResponse>(buildUrl(currentPage))
        }

        return fetchPage(0).pipe(
            switchMap((firstResponse) => {
                const totalPages = Math.ceil(firstResponse.totalCount / limit)
                if (totalPages <= 1) {
                    return of(firstResponse.result)
                }

                return range(1, totalPages - 1).pipe(
                    concatMap((pageIndex) => fetchPage(pageIndex)),
                    reduce(
                        (acc, response) => acc.concat(response.result),
                        firstResponse.result
                    )
                )
            })
        )
    }

    getCheckinsPaginated(tenantId: string, limit: number, page: number, startDate?: Date, endDate?: Date, locationId?: string | null): Observable<CheckinsResponse> {
        const params: string[] = [`tenantId=${tenantId}`, `limit=${limit}`, `page=${page}`]

        if (startDate && endDate) {
            params.push(`startDate=${moment(startDate).utc().toISOString()}`)
            params.push(`endDate=${moment(endDate).utc().toISOString()}`)
        }

        if (locationId) {
            params.push(`locationId=${locationId}`)
        }

        const url = `${this.environment.appApiHost}/api/${tenantId}/admin/directory/tenantCheckins?${params.join('&')}`
        return this.http.get<CheckinsResponse>(url)
    }

    getCheckinLocations(tenantId: string): Observable<CheckinLocationOption[]> {
        return this.http.get<CheckinLocationOption[]>(`${this.environment.appApiHost}/api/${tenantId}/directory/checkins?api-version=1.21.0`)
    }
}

